
type DataValue = string | number | null | undefined;

export const convertToCSV = (data: Record<string, DataValue>[]): string => {
  if (!data.length) return '';

  // Get headers from the first object
  const headers = Object.keys(data[0]);

  // Create header row
  const headerRow = headers.map(header => `"${header}"`).join(',');

  // Create data rows
  const dataRows = data.map(row => {
    return headers.map(header => {
      const value = row[header];
      
      // Handle null or undefined
      if (value === null || value === undefined) {
        return '""';
      }
      
      // If it's a number, return it without quotes
      if (typeof value === 'number') {
        return value.toString();
      }
      
      // For strings, wrap in quotes and escape any existing quotes
      return `"${value.toString().replace(/"/g, '""')}"`;
    }).join(',');
  });

  return [headerRow, ...dataRows].join('\n');
};

export const downloadCSV = (data: Record<string, DataValue>[], originalFileName: string) => {
  const csv = convertToCSV(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  // Replace .pdf with .csv in the filename
  const csvFileName = originalFileName.toLowerCase().replace(/\.pdf$/i, '.csv');
  
  link.href = url;
  link.setAttribute('download', csvFileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
